export default __webpack_public_path__ + "static/media/combot-white.f8ed3096.svg";